<template>
    <div>

        <div style="padding-top: 5rem; margin-top: 2rem; margin-bottom: 0rem;" >
            <div class="d-table">
                <div class="d-table-cell">
                    <div class="container" style="margin-top: 14px">
                        <h5 class="order-conf" style="color: #5457c1; margin-bottom: 20px">Form to fill out after ordering 🎉🎉🎉</h5>
                        <h1 style="height:70px;">SAMPLE form for your <span style="color: #5457c1">AI input</span></h1>
                        <div class="mobile-center" style="display: flex; margin-top: 4rem">
                            <h2>&#129302;</h2>
                            <h6 style="padding-left: 10px; margin: auto 0">Allow up to 48h to receive the first draft</h6>
                        </div>

                        <div style="margin-top: 2rem; border: 2px solid #5457c1" class="alert alert-light" role="alert">
                            The greater the level of detail you provide, the more comprehensive your petition can become, reducing the need for numerous iterations with respect to the cover letter and reference letters
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="d-table" style="padding-top: 3rem; background-color: #f9fafb">
            <div class="d-table-cell">
                <div class="container">

                    <div class="row" style="margin-bottom: 3rem">
                        <h5 class="col-12">Your profile overview</h5>

                        <div class="col-md-8" style="padding-left: 2rem; padding-top: 1rem">
                            <div class="form-group">
                                <label for="email" style="margin-bottom: 3px">Confirm your e-mail</label>
                                <input type="email" class="form-control" id="email" @input="handleInputChange('email')" aria-describedby="email" placeholder="E-mail to receive Selfpetition AI draft" style="border-radius: 5px; border-color: #44ce6f" v-model="userBackground.email">
                            </div>
                            <div class="form-group">
                                <label for="profession" style="margin-bottom: 3px">Profession and job title</label>
                                <input type="text" class="form-control" id="profession" @input="handleInputChange('profession')" aria-describedby="profession" style="border-radius: 5px; border-color: #44ce6f" v-model="userBackground.profession">
                            </div>
                            <div class="form-group">
                                <label for="company" style="margin-bottom: 3px">Current company</label>
                                <input type="text" class="form-control" id="company" @input="handleInputChange('company')" aria-describedby="company" style="border-radius: 5px; border-color: #44ce6f" v-model="userBackground.company">
                            </div>
                            <div class="form-group">
                                <label for="industry" style="margin-bottom: 3px">Industry or sector that you work in</label>
                                <input type="text" class="form-control" id="industry" @input="handleInputChange('industry')" aria-describedby="industry" style="border-radius: 5px; border-color: #44ce6f" v-model="userBackground.industry">
                            </div>
                            <div class="form-group">
                                <label for="linkedin" style="margin-bottom: 3px">LinkedIn profile</label>
                                <input type="text" class="form-control" id="linkedin" @input="handleInputChange('linkedin')" aria-describedby="linkedin" placeholder="https://www.linkedin.com/" style="border-radius: 5px; border-color: #44ce6f" v-model="userBackground.linkedin">
                            </div>
                            <div class="form-group" style="margin-bottom: 0px;">
                                <label for="resume" style="margin-bottom: 0px;">
                                    <span>Upload Resume</span>
                                    <div style="cursor: pointer; font-size: 2.5rem; margin-left: 2px;"><font-awesome-icon icon="file-upload" style="color: #44ce6f;"/></div>
                                </label>
                                <input type="file" class="form-control-file" id="resume" ref="resume" v-on:change="() => checkFileSize('resume')" @input="handleInputChange('resume')" style="display: none;">
                                <p v-if="userFiles.resume" style="display: flex; align-items: center">Uploaded: {{ userFiles.resumeName }}
                                    <span v-on:click="() => deleteFile('resume')" style="margin-left: 18px; font-size: 18px; cursor: pointer;">
                                        <font-awesome-icon icon="trash-can" />
                                    </span>
                                </p>
                            </div>
                        </div>

<!-- Alerts to validate submission-->
                        <div class="col-8" style="padding-left: 2rem; padding-top: 1rem">
                            <div v-if="submittedAlert && !submittedSuccess && !isEmail" class="alert alert-warning" role="alert" style="margin-bottom: 5px">
                                <div style="font-weight: 500">Enter a valid e-mail</div>
                            </div>
                            
                            <div v-if="submittedAlert && !submittedSuccess && !userBackground.profession" class="alert alert-warning" role="alert" style="margin-bottom: 5px">
                                <div style="font-weight: 500">Your profession is required</div>
                            </div>
                            
                            <div v-if="submittedAlert && !submittedSuccess && !userBackground.company" class="alert alert-warning" role="alert" style="margin-bottom: 5px">
                                <div style="font-weight: 500">Your company is required (current or previous one)</div>
                            </div>
<!-- Alerts to validate Resume submission-->
                            <div v-if="submittedAlert && !submittedSuccess && !userBackground.linkedin && !userFiles.resumeName" class="alert alert-warning" role="alert" style="margin-bottom: 5px">
                                <div style="font-weight: 500">At least one is required: LinkedIn or Resume</div>
                            </div>
                            <div v-if="resumeTooLarge" class="alert alert-danger" role="alert" style="margin-bottom: 5px">
                                File size exceeds 3MB limit: you can also e-mail us larger files at ceo@selfpetitionusa.com
                            </div>
                        </div>

                    </div>

                    <div class="row" style="margin-bottom: 3rem">
                        <h5 class="col-12">Proposed endeavor</h5>
                        <div class="col-12" style="padding-left: 2rem; padding-top: 1rem">
                            <div class="form-group">
                                <label for="roleDesc" style="margin-bottom: 3px">Describe your current role
                                    <ul>
                                        <li style="font-weight: 400">How company or clients benefit from your work?</li>
                                        <li style="font-weight: 400">Who benefits from your work: is it internal team, external clients, other?</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="roleDesc" @input="handleInputChange('currentRole')" aria-describedby="roleDesc" rows="4" style="border-radius: 5px; border-color: #44ce6f" v-model="userProposedEndeavor.roleDesc"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="proposedEndeavor" style="margin-bottom: 3px">Suggest your proposed endeavor
                                    <ul>
                                        <li style="font-weight: 400">The proposed endeavor is the specific future work or project you intend to carry out in the U.S.</li>
                                        <li style="font-weight: 400">It's ok if you don't have one yet, we will provide several choices</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="proposedEndeavor" @input="handleInputChange('endeavor')" aria-describedby="proposedEndeavor" rows="4" style="border-radius: 5px; border-color: #44ce6f" v-model="userProposedEndeavor.proposedEndeavor"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="proposedEndeavorNiche" style="margin-bottom: 3px">In this endeavor, are you looking to focus on a specific project, client segment, industry, or niche area?
                                    <ul>
                                        <li style="font-weight: 400">It's ok if you don't have endeavor focus yet, we will provide several choices</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="proposedEndeavorNiche" @input="handleInputChange('endeavorNiche')" aria-describedby="proposedEndeavorNiche" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProposedEndeavor.proposedEndeavorNiche"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="proposedEndeavorGeography" style="margin-bottom: 3px">In this endeavor, are you looking to focus on a specific U.S. state or geographic region in the U.S.?
                                    <ul>
                                        <li style="font-weight: 400">If not, we will describe your proposed endeavor as national in scope</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="proposedEndeavorGeography" @input="handleInputChange('endeavorGeography')" aria-describedby="proposedEndeavorGeography" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProposedEndeavor.proposedEndeavorGeography"></textarea>
                            </div>
                            <div class="form-group">
                                <label style="margin-bottom: 8px">How do you plan to execute your proposed endeavor in the U.S.?
                                    <div style="font-weight: 400">Select the option that aligns with your previous experience because USCIS expects you to be qualified to carry out the proposed endeavor</div>
                                </label>
                                <div style="margin: 0px 28px 20px">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="executionEmployee" @input="handleInputChange('endeavorExecution')" name="proposedEndeavorExecution" value="employee" v-model="userProposedEndeavor.executionPlan">
                                        <label class="form-check-label" for="executionEmployee" style="font-weight:500">As an employee</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="executionEntrepreneur" @input="handleInputChange('endeavorExecution')" name="proposedEndeavorExecution" value="entrepreneur" v-model="userProposedEndeavor.executionPlan">
                                        <label class="form-check-label" for="executionEntrepreneur" style="font-weight:500">As an entrepreneur</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="executionConsultant" @input="handleInputChange('endeavorExecution')" name="proposedEndeavorExecution" value="consultant" v-model="userProposedEndeavor.executionPlan">
                                        <label class="form-check-label" for="executionConsultant" style="font-weight:500">As an independent consultant or contractor</label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="pastProject1" style="margin-bottom: 3px">Your <b>PAST</b> work or project (example #1)
                                    <ul>
                                        <li style="font-weight: 400">Who benefited from the project?</li>
                                        <li style="font-weight: 400">What were the positive outcomes? Include metrics such as revenue generated, number of new clients, percentage growth, efficiency improvements, other relevant</li>
                                        <li style="font-weight: 400">What did you contribute? Include specifics like the number of presentations given, lines of code written, teams coordinated, other relevant</li>
                                    </ul>
                                </label>    
                                <textarea class="form-control" id="pastProject1" @input="handleInputChange('pastProject1')" aria-describedby="pastProject1" rows="4" style="border-radius: 5px; border-color: #44ce6f" v-model="userProposedEndeavor.pastProject1"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="pastProject2" style="margin-bottom: 3px">Your <b>PAST</b> work or project (example #2)
                                    <ul>
                                        <li style="font-weight: 400">Who benefited from the project?</li>
                                        <li style="font-weight: 400">What were the positive outcomes? Include metrics such as revenue generated, number of new clients, percentage growth, efficiency improvements, other relevant</li>
                                        <li style="font-weight: 400">What did you contribute? Include specifics like the number of presentations given, lines of code written, teams coordinated, other relevant</li>
                                    </ul>
                                </label>  
                                <textarea class="form-control" id="pastProject2" @input="handleInputChange('pastProject2')" aria-describedby="pastProject2" rows="4" style="border-radius: 5px; border-color: #44ce6f" v-model="userProposedEndeavor.pastProject2"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="futureProject1" style="margin-bottom: 3px">Vision for the next 2–5 Years: <b>FUTURE</b> work or project (example #1)
                                    <ul>
                                        <li style="font-weight: 400">What is the goal of this project?</li>
                                        <li style="font-weight: 400">Who will benefit from this project if successful?</li>
                                        <li style="font-weight: 400">What will you contribute to this project?</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="futureProject1" @input="handleInputChange('futureProject1')" aria-describedby="futureProject1" rows="4" style="border-radius: 5px; border-color: #44ce6f" v-model="userProposedEndeavor.futureProject1"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="futureProject2" style="margin-bottom: 3px">Vision for the next 2–5 Years: <b>FUTURE</b> work or project (example #2)
                                    <ul>
                                        <li style="font-weight: 400">What is the goal of this project?</li>
                                        <li style="font-weight: 400">Who will benefit from this project if successful?</li>
                                        <li style="font-weight: 400">What will you contribute to this project?</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="futureProject2" @input="handleInputChange('futureProject2')" aria-describedby="futureProject2" rows="4" style="border-radius: 5px; border-color: #44ce6f" v-model="userProposedEndeavor.futureProject2"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="row" style="margin-bottom: 3rem">
                        <h5 class="col-12">Prong 1 - Substantial merit and national importance</h5>
                        <div class="col-12" style="padding-left: 2rem; padding-top: 1rem">
                            <div class="form-group">
                                <label for="nationalImportance" style="margin-bottom: 3px">Do you have particular points or topics you wish to underline in national importance?
                                    <ul>
                                        <li style="font-weight: 400">Ok if not, we will take care of it</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="nationalImportance" @input="handleInputChange('nationalImportance')" aria-describedby="nationalImportance" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng1.nationalImportance"></textarea>
                            </div>                       
                            <div class="form-group">
                                <label for="jobCreation" style="margin-bottom: 3px">Does your role contribute to job creation in the U.S.?
                                    <ul>
                                        <li style="font-weight: 400">This could be through directly hiring employees, or indirectly by enabling other companies to grow and create jobs - for example, through your services, funding, partnerships, or strategic support</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="jobCreation" @input="handleInputChange('jobs')" aria-describedby="jobCreation" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng1.jobCreation"></textarea>
                            </div>   
                            <div class="form-group">
                                <label for="scaleImpact" style="margin-bottom: 3px">Do your actions affect large number of people - thousands or even millions across the U.S.?
                                    <ul>
                                        <li style="font-weight: 400">This could be through a widely used product, service, policy, or system that has national reach or influence</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="scaleImpact" @input="handleInputChange('scale')" aria-describedby="scaleImpact" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng1.scaleImpact"></textarea>
                            </div>   
                            <div class="form-group">
                                <label for="impactOnIndustry" style="margin-bottom: 3px">How your actions benefit anyone <b>BEYOND</b> your employer or direct clients?
                                    <ul>
                                        <li style="font-weight: 400">For example, by influencing industry practices, setting new standards, contributing to open source tools, publishing research, or sharing knowledge through speaking or writing</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="impactOnIndustry" @input="handleInputChange('scope')" aria-describedby="impactOnIndustry" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng1.impactOnIndustry"></textarea>
                            </div>   
                            <div class="form-group">
                                <label for="fundsInflow" style="margin-bottom: 3px">Are you involved in facilitating flow of funds from overseas into the U.S.?
                                    <ul>
                                        <li style="font-weight: 400">This could include foreign investments, international partnerships, or securing loans that support U.S. based projects or companies</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="fundsInflow" @input="handleInputChange('fundsInflow')" aria-describedby="fundsInflow" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng1.fundsInflow"></textarea>
                            </div>   
                        </div>
                    </div>

                    <div class="row" style="margin-bottom: 3rem">
                        <h5 class="col-12">Prong 2 - Well positioned to advance the proposed endeavor (knowledge)</h5>
                        <div class="col-12" style="padding-left: 2rem; padding-top: 1rem">
                            <div class="form-group">
                                <label for="degrees" style="margin-bottom: 3px">List all your degrees: Bachelors, Masters, PhD, MBA, etc.</label>
                                <textarea class="form-control" id="degrees" @input="handleInputChange('degrees')" aria-describedby="degrees" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng2Education.degrees"></textarea>
                            </div>     
                            <div class="form-group">
                                <label for="certificates" style="margin-bottom: 3px">List <b>certifications</b> that are required to carry out your proposed work in the U.S. <b>OR</b> that show you are an above average professional. Generic or easily obtained certifications commonly held by most professionals typically do not meet USCIS standards. What certifications to include:
                                    <ul>
                                        <li style="font-weight: 400"><span style="font-weight: 500">Necessary to carry out proposed work:</span> Essential to perform the work you are proposing to undertake in the U.S.</li>
                                        <li style="font-weight: 400"><span style="font-weight: 500">Legally or professionally required</span>: Necessary to carry out specific tasks in regulated industries (e.g. healthcare, engineering, finance, other regulated industries)</li>
                                        <li style="font-weight: 400"><span style="font-weight: 500">Difficult to obtain</span>: Recognized as rigorous or selective, and not commonly held by the average professional in your field</li>
                                        <li style="font-weight: 400"><span style="font-weight: 500">Highly regarded</span>: Distinguishes top tier professionals or is required for advanced, leadership, or specialized roles</li>
                                        <li style="font-weight: 400"><span style="font-weight: 500">Granted by a recognized authority:</span> Issued by accredited institutions, licensing bodies, or well respected professional organizations</li>
                                        <li style="font-weight: 400"><span style="font-weight: 500">Niche or specialized focus:</span> Differentiates you from average professional in the field</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="certificates" @input="handleInputChange('certificates')" aria-describedby="certificates" rows="3" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng2Education.certificates"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="associations" style="margin-bottom: 3px">List <b>professional associations</b> that maximize your impact in carrying out your proposed work in the U.S. <b>OR</b> demonstrate that you are an above average professional
                                    <ul>
                                        <li style="font-weight: 400"><span style="font-weight: 500">Maximize impact of your proposed work:</span> Will enable you to achieve the greatest results in the work you plan to undertake in the U.S.</li>
                                        <li style="font-weight: 400"><span style="font-weight: 500">Legally or professionally required</span>: Necessary to carry out specific tasks in regulated industries (e.g. healthcare, engineering, finance, other regulated industries)</li>
                                        <li style="font-weight: 400"><span style="font-weight: 500">Difficult to obtain</span>: Involves a selective application, peer review, or other competitive process not easily accessible to the average professional</li>
                                        <li style="font-weight: 400"><span style="font-weight: 500">Invitation based:</span> Offered through recommendation, nomination or invitation, indicating recognition by peers or industry leaders</li>
                                        <li style="font-weight: 400"><span style="font-weight: 500">Higher tier membership:</span> Reserved for professionals with advanced experience or contributions, such as Senior Member or Fellow status</li>
                                        <li style="font-weight: 400"><span style="font-weight: 500">Active contribution:</span> You are actively involved through activities such as publishing, presenting at events, holding committee positions, or other actions</li>
                                        <li style="font-weight: 400"><span style="font-weight: 500">Niche or specialized focus:</span> Directly aligned with your highly specialized work</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="associations" @input="handleInputChange('associations')" aria-describedby="associations" rows="3" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng2Education.associations"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="row" style="margin-bottom: 3rem">
                        <h5 class="col-12">Prong 2 - Well positioned to advance the proposed endeavor (above average professional)</h5>
                        <div class="col-12" style="padding-left: 2rem; padding-top: 1rem">
                            <div class="form-group">
                                <label for="salary" style="margin-bottom: 3px">What is your total compensation?
                                    <ul>
                                        <li style="font-weight: 400">Break down your compensation into base salary, bonuses, RSUs, equity, etc.</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="salary" @input="handleInputChange('salary')" aria-describedby="salary" rows="2" placeholder="To benchmark your salary against the market average" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng2Demand.salary"></textarea>
                            </div>     
                            <div class="form-group">
                                <label for="promotions" style="margin-bottom: 3px">Have you received promotions or above average bonuses in your current role?</label>
                                <textarea class="form-control" id="promotions" @input="handleInputChange('promotions')" aria-describedby="promotions" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng2Demand.promotions"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="awards" style="margin-bottom: 3px">Have you been honored with awards, chosen for internal sponsorship or mentorship programs?</label>
                                <textarea class="form-control" id="awards" @input="handleInputChange('awards')" aria-describedby="awards" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng2Demand.awards"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="patents" style="margin-bottom: 3px">Do you possess patented inventions that have been commercialized?</label>
                                <textarea class="form-control" id="patents" @input="handleInputChange('patents')" aria-describedby="patents" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng2Demand.patents"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="citations" style="margin-bottom: 3px">Have you been cited, quoted, or had your work referenced in any publications? Have your publications been viewed or downloaded?
                                    <ul>
                                        <li style="font-weight: 400">We are not looking for isolated or minor citations. What matters is whether your work has been cited frequently or by a well known, respected source</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="citations" @input="handleInputChange('citations')" aria-describedby="citations" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng2Demand.citations"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="mediaRecognition" style="margin-bottom: 3px">Have you or your work been mentioned in the media?
                                    <ul>
                                        <li style="font-weight: 400">Share links or attach files from articles, interviews, blogs, or industry features</li>
                                        <li style="font-weight: 400">Mentions can be in any language, AI will translate and summarize the context as needed</li>
                                        <li style="font-weight: 400">Not sure if you've been mentioned? Search your name with keywords related to your company, projects, or expertise on Google - check across tabs like All, Images, News, and Forums</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="mediaRecognition" @input="handleInputChange('media')" aria-describedby="mediaRecognition" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng2Demand.mediaRecognition"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="conferences" style="margin-bottom: 3px">Have you spoken at any conferences, panels, workshops, or industry events?
                                    <ul>
                                        <li style="font-weight: 400">Describe each event, including the type of audience (company employees, students, or professionals in a specific field), the approximate size of the event, the topic of your presentation, and your specific role</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="conferences" @input="handleInputChange('conferences')" aria-describedby="conferences" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng2Demand.conferences"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="exceptionalAbility" style="margin-bottom: 3px">When you compare yourself to professionals in a similar role, what is above average or exceptional about you?
                                    <ul>
                                        <li style="font-weight: 400">Avoid general traits like “hard working” or “passionate”. Instead focus on tangible strengths, specific skill, approach, ability to cover areas that others are not qualified for or examples that set you apart</li>
                                    </ul>
                                </label>
                                <textarea class="form-control" id="exceptionalAbility" @input="handleInputChange('exceptionalAbility')" aria-describedby="exceptionalAbility" rows="2" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng2Demand.exceptionalAbility"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="row" style="margin-bottom: 5rem">
                        <h5 class="col-12">Prong 3 - Beneficial to the U.S. to waive the job offer and labor certification</h5>
                        <div class="col-12" style="padding-left: 2rem; padding-top: 1rem">
                            <div class="form-group">
                                <label for="urgency" style="margin-bottom: 3px">Is there any urgency or time sensitivity related to carrying out your proposed work in the U.S.?</label>
                                <textarea class="form-control" id="urgency" @input="handleInputChange('urgency')" aria-describedby="urgency" rows="3" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng3.urgency"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="impracticability" style="margin-bottom: 3px">If your employer is involved in your EB-2 NIW petition, such as coordinating the process, covering filing fees, or preparing the petition through their internal legal department, is there a specific reason why a PERM petition is not practical or why the NIW route is more suitable?</label>
                                <textarea class="form-control" id="impracticability" @input="handleInputChange('permImpractical')" aria-describedby="impracticability" rows="3" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng3.impracticability"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="additionalInfo" style="margin-bottom: 3px">Is there any other information you would like to add to the EB-2 NIW draft?</label>
                                <textarea class="form-control" id="additionalInfo" @input="handleInputChange('additionalInfo')" aria-describedby="additionalInfo" rows="3" style="border-radius: 5px; border-color: #44ce6f" v-model="userProng3.additionalInfo"></textarea>
                            </div>
                            <div class="form-group" style="height: 6rem">
                                <label for="additionalFiles" style="margin-bottom: 0px;">
                                    Upload Additional Documents - if relevant
                                    <div style="cursor: pointer; font-size: 2.5rem; margin-left: 2px;"><font-awesome-icon icon="file-upload" style="color: #44ce6f;"/></div>
                                </label>
                                <input type="file" class="form-control-file" id="additionalFiles" ref="additionalFiles" multiple v-on:change="checkMultipleFileSizes" @input="handleInputChange('additionalFiles')" style="display: none;">
                                <p v-for="(file, index) in userFiles.additionalFiles" :key="'uploaded-additional-file-' + index" style="display: flex; align-items: center; margin-bottom: 0px">
                                    Uploaded: {{ file.name }}
                                    <span v-on:click="() => deleteAdditionalFile(index)" style="margin-left: 18px; font-size: 18px; cursor: pointer;">
                                        <font-awesome-icon icon="trash-can" />
                                    </span>
                                </p>
                            </div>
                            <div v-if="fileTooLarge" class="alert alert-danger" role="alert">
                                File size exceeds 3MB limit: you can also e-mail us larger files at ceo@selfpetitionusa.com
                            </div>
                        </div>
                    </div>

                    <form  @submit.prevent="submit()" class="row" style="justify-content: center; margin-bottom: 5rem">
                        <div class="col-xl-3 col-sm-5 col-10">
                            <button type="submit" class="btn btn-primary" style="width: 100%; margin-bottom: 5px">Submit</button>
                            <div :class="{ nonvisible: !submitted || submittedSuccess }" class="alert alert-warning" role="alert" style="font-weight: 500; text-align: center">Oops... check your inputs in "Your profile overview"</div>
                        </div>
                        <div v-if="submittedSuccess" class="col-12" style="margin-top: 1rem">
                            <div class="alert alert-primary" role="alert" style="font-weight: 500; text-align: center">
                                <h6>🎉 This form is just a sample 🎉</h6>
                                <div>Make sure to first <a href="/checkout-selfpetition-ai"><span style="text-decoration: underline">place the order</span></a> and process payment</div>
                            </div>
                       </div>
                    </form>

                </div>
            </div>
        </div>
    
    </div>
</template>

<script>

import {mapActions} from "vuex";

    export default {
        name: 'GreenCardAiForm1',
        data () {
            return {
                userBackground: {
                    email: '',
                    profession: '',
                    company: '',
                    industry: '',
                    linkedin: '',
                },
                userProposedEndeavor: {
                    roleDesc: '',
                    proposedEndeavor: '',
                    proposedEndeavorNiche: '',
                    proposedEndeavorGeography: '',
                    executionPlan: [],
                    pastProject1: '',
                    pastProject2: '',
                    futureProject1: '',
                    futureProject2: '',
                },
                userProng1: {
                    nationalImportance: '',
                    jobCreation: '',
                    scaleImpact: '',
                    impactOnIndustry: '',
                    fundsInflow: '',
                },
                userProng2Education: {
                    degrees: '',
                    certificates: '',
                    associations: '',
                },
                userProng2Demand: {
                    salary: '',
                    promotions: '',
                    awards: '',
                    patents: '',
                    citations: '',
                    mediaRecognition: '',
                    conferences: '',
                    exceptionalAbility: '',
                },
                userProng3: {
                    urgency: '',
                    impracticability: '',
                    additionalInfo: '',
                },
                userFiles: {
                    resumeName: '',
                    resume: '',
                    additionalFiles: [],
                },
                submitted: false,
                submittedSuccess: false,
                submittedAlert: false,
                isEmail: false,
                fileTooLarge: false,
                resumeTooLarge: false,
            }
        },
        methods: {
            ...mapActions('account', ['apply']),
            sendEvent(eventType) {
              if (window.gtag) {
                window.gtag('event', eventType); // google analytics
              }
            },
            validateEmail () {
                this.isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(this.userBackground.email);
            },
            checkFileSize(refName, maxFileSize = 3 * 1024 * 1024) {
                const fileInput = this.$refs[refName];
                if (fileInput.files.length === 0) return; // Exit if no file selected
                const fileSize = fileInput.files[0].size;
                let sizeLimitExceeded = (fileSize > maxFileSize);

                if (sizeLimitExceeded) {
                    fileInput.value = ''; // Correct way to reset the file input
                    if (refName === 'resume') {
                        this.resumeTooLarge = true;
                    } else {
                        this.fileTooLarge = true;
                    }
                    setTimeout(() => {
                        if (refName === 'resume') {
                            this.resumeTooLarge = false;
                        } else {
                            this.fileTooLarge = false;
                        }
                    }, 5000);
                } else {
                    if (refName === 'resume') {
                        this.setImage('resume');
                    } else {
                        this.checkMultipleFileSizes();
                    }
                }
            },
            checkMultipleFileSizes() {
                const files = this.$refs.additionalFiles.files;
                Array.from(files).forEach(file => {
                    if (file.size <= 3 * 1024 * 1024) { // 3MB size limit per file
                        this.readAndUploadFile(file, 'additionalFiles');
                    } else {
                        this.fileTooLarge = true;
                        setTimeout(() => {
                            this.fileTooLarge = false;
                        }, 5000);
                    }
                });
            },
            readAndUploadFile(file, refName) {
                const reader = new FileReader();
                reader.onload = () => {
                    this.userFiles[refName] = this.userFiles[refName] || [];
                    this.userFiles[refName].push({
                        name: file.name,  // Ensure the file name is stored
                        data: reader.result
                    });
                };
                reader.onerror = error => console.log('Error: ', error);
                reader.readAsDataURL(file);
            },
            setImage(refName) {
                this.getBase64(this.$refs[refName].files[0], refName);
            },
            getBase64(file, refName) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    if (refName === 'resume') {
                        this.userFiles.resume = reader.result;
                        this.userFiles.resumeName = file.name;
                    } else {
                        let index = parseInt(refName.slice(-1)) - 1;
                        if (!this.userFiles.additionalFiles[index]) {
                            this.userFiles.additionalFiles[index] = {};
                        }
                        this.userFiles.additionalFiles[index].data = reader.result;
                        this.userFiles.additionalFiles[index].name = file.name;
                    }
                };
                reader.onerror = function (error) {
                    console.log('Error: ', error);
                };
            },
            deleteFile(refName) {
                this.userFiles[refName] = '';
                this.userFiles[`${refName}Name`] = '';
            },
            deleteAdditionalFile(index) {
                this.userFiles.additionalFiles.splice(index, 1);
            },
            clearInputs () {
                this.userBackground.email = '';
                this.userBackground.profession = '';
                this.userBackground.company = '';
                this.userBackground.industry = '';
                this.userBackground.linkedin = '';
                
                this.userProposedEndeavor.roleDesc = '';
                this.userProposedEndeavor.proposedEndeavor = '';
                this.userProposedEndeavor.proposedEndeavorNiche = '';
                this.userProposedEndeavor.proposedEndeavorGeography = '';
                this.userProposedEndeavor.executionPlan = [];
                this.userProposedEndeavor.pastProject1 = '';
                this.userProposedEndeavor.pastProject2 = '';
                this.userProposedEndeavor.futureProject1 = '';
                this.userProposedEndeavor.futureProject2 = '';

                this.userProng1.nationalImportance = '';
                this.userProng1.jobCreation = '';
                this.userProng1.scaleImpact = '';
                this.userProng1.impactOnIndustry = '';
                this.userProng1.fundsInflow = '';

                this.userProng2Education.degrees = '';
                this.userProng2Education.certificates = '';
                this.userProng2Education.associations = '';

                this.userProng2Demand.salary = '';
                this.userProng2Demand.promotions = '';
                this.userProng2Demand.awards = '';
                this.userProng2Demand.patents = '';
                this.userProng2Demand.citations = '';
                this.userProng2Demand.mediaRecognition = '';
                this.userProng2Demand.conferences = '';
                this.userProng2Demand.exceptionalAbility = '';

                this.userProng3.urgency = '';
                this.userProng3.impracticability = '';
                this.userProng3.additionalInfo = '';

                this.userFiles.resumeName = '';
                this.userFiles.resume = '';
                this.userFiles.additionalFiles = [];
            },
            handleInputChange(field) {
                this.submitted = false; // Reset the submission status when any input changes
                if (field === 'email') {
                    this.validateEmail();
                }
            },
            submit() {
                this.validateEmail ();
                this.submitted = true;
                this.submittedAlert = true;
                if(this.isEmail && this.userBackground.profession && this.userBackground.company && (this.userBackground.linkedin || this.userFiles.resumeName)) {
                    this.submittedSuccess = true;
                    this.clearInputs();
                }
            }
        }
    }

</script>

<style scoped>

input[type="checkbox"] {
    display: none; /* Hide default checkbox */
}

input[type="checkbox"] + label::before {
    content: '';
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    font-size: 12px;
    color: #44ce6f;
    border: 1px solid #44ce6f;
    border-radius: 4px;
    margin-right: 8px;
    vertical-align: middle;
}

input[type="checkbox"]:checked + label::before {
    content: 'X';
    background-color: #44ce6f;
    color: white;
    border-color: #44ce6f;
}

</style>
